import styled, { css } from 'styled-components';
import { hover } from 'src/components/utils';

export const Segments = styled.div<{ $overlay?: boolean }>(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s1};
    width: 100%;
    max-width: none;
  `,
);

export const ProgressTrack = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Segment = styled.span<{ $filled: boolean; $overlay: boolean }>(
  ({ theme, $filled, $overlay }) => css`
    flex: 1;
    height: ${theme.sz.s1};
    border-radius: ${theme.bo.round};
    background-color: ${
      $filled ? theme.co.primary20 : $overlay ? 'hsla(0, 0%, 100%, 0.35)' : theme.co.neutral95
    };
    transition: background-color 0.3s ease;
  `,
);

export const ExitButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: ${theme.sz.s1};
    border: 0;
    border-radius: ${theme.bo.round};
    background: none;
    color: ${theme.co.neutral10};
    font-size: ${theme.sz.s5};
    cursor: pointer;

    &:hover {
      background-color: ${hover(theme.co.blobBackground)};
    }

    ${theme.focusVisible};
  `,
);

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
  `,
);
